<template>
    <el-card shadow="hover">
        <label slot="header">地址选择</label>
        <el-divider content-position="left">value-type="String" separator="/" 返回字符串类型-以/分割字符串:{{address}}</el-divider>
        <j-link-address value-type="String" separator="/" style="width: 300px;" v-model="address" @change="addressChange" />
        <el-divider content-position="left">文本解析</el-divider>
        <j-link-address type="text" v-model="address" separator="/" />
        <el-divider content-position="left">仅显示省和市 value-type="String" separator="/" 返回数组{{addressArray}}</el-divider>
        <j-link-address value-type="Array" scope="city" style="width: 400px;" v-model="addressArray" />
        <el-divider content-position="left">数组解析</el-divider>
        <j-link-address type="text" v-model="addressArray" />
        <el-divider content-position="left">文本模式（数组）</el-divider>
        <j-link-address type="text" v-model="addressTextArray" />
        <el-divider content-position="left">文本模式（字符串）</el-divider>
        <j-link-address type="text" v-model="addressTextString" separator="," />
    </el-card>
</template>

<script>
    import JLinkAddress from "./JLinkAddress";
    export default {
        components: {
            JLinkAddress
        },
        data() {
            return {
              addressArray: [],
              address: '',
              addressTextArray: ["220000","220100","220102"],
              addressTextString: "220000,220100,220102"
            }
        },
        methods: {
          addressChange (v, select, textSelect) {
            console.log(v, select, textSelect)
          }
        }
    }
</script>
